import { DatePicker } from "antd";
import dayjs, { type Dayjs } from "dayjs";
import { useEffect, useState } from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placement?: "bottomLeft" | "bottomRight" | "topLeft" | "topRight";
  showTime?: boolean;
};

const DatePickerColumn = ({ value, onChange, disabled, placement = "bottomLeft", showTime }: Props) => {
  const [date, setDate] = useState<Dayjs | null>(null);

  useEffect(() => {
    if (value) {
      const parsedDate = dayjs(value);
      setDate(parsedDate.isValid() ? parsedDate : null);
    }
  }, [value]);

  const handleChange = (selectedDate: Dayjs | null) => {
    setDate(selectedDate);
    const formattedDate = selectedDate?.format("YYYY-MM-DD:HH:mm:ss") || "";
    onChange(formattedDate);
  };

  return (
    <DatePicker
      showTime={showTime}
      format="DD/MM/YYYY - HH:mm:ss"
      placement={placement}
      value={date}
      disabled={disabled}
      onChange={handleChange}
    />
  );
};

export default DatePickerColumn;
